




























import { Component, Prop, Vue, Watch, Emit, Mixins } from 'vue-property-decorator';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import multiselect from 'vue-multiselect';
import { Mounted } from '../decorators';
import { EventBus, hasElements, TypeEventBus, getDateFromDateFormatApi } from '../utils';
import { RootStoreHelper, NotificationStoreHelper } from '../../core/mixins';
import { FilterDateEvent, getDateByFormat, Method } from '../utils';
import { TypeFilterDate } from '../models';

@Component({
    components: {
        multiselect
    }
})
export default class HourSelector extends Mixins(RootStoreHelper, NotificationStoreHelper) {
    hoursSelector: any = [];
    hourSelected: any = null;
    @Prop({ default: '00:00' }) value: string;
    @Prop({ default: '' }) placeholder: string;
    @Prop({ default: '' }) label: string;

    mounted() {
        this.hourSelected = this.value;
    }

    @Watch('value')
    observableValue(value) {
        this.selectHour(value);
    }

    get getHoursOptions() {
        for (let hour = 0; hour < 24; hour++) {
            this.hoursSelector.push(moment({ hour, minute: 0 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 15 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 30 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 45 }).format('HH:mm'));
            this.hoursSelector.push(moment({ hour, minute: 55 }).format('HH:mm'));
        }
        return this.hoursSelector;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    selectHour(selectedHour) {
        let validateTime = this.validateTime(selectedHour);
        if (validateTime.isValid()) {
            this.hourSelected = selectedHour;
        } else {
            this.hourSelected = '';
        }
        this.$emit('change-value', this.hourSelected);
    }

    validateTime(time) {
        return moment(time, 'HH:mm', true);
    }
}
